/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import MarkdownLayout from "components/MarkdownLayout";
import Button from "components/Button";
import Media from "components/Media";
export const meta = {
  title: "Wallpapers",
  desc: "Make Raycast stand out, and your desktop pretty."
};
const MDXLayout = ({children}) => _jsx(MarkdownLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p"
  }, props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Autumnal Peach"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/autumnal-peach-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/autumnal-peach.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Autumnal Peach (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Blossom"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/blossom-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/blossom-2.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Blossom (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Blushing Fire"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/blushing-fire-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/blushing-fire.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Blushing Fire (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Bright Rain"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/bright-rain-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/bright-rain.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Bright Rain (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Floss"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/floss-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/floss.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Floss (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Glass Rainbow"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/glass-rainbow-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/glass-rainbow.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Glass Rainbow (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Good Vibes"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/good-vibes-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/good-vibes.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Good Vibes (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Moonrise"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/moonrise-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/moonrise.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Moonrise (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Ray of Lights"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/ray-of-lights-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/ray-of-lights.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Ray of Lights (5120 x 2880 pixels)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Rose Thorn"
    }), "\n", _jsx(Media, {
      src: "/uploads/wallpapers/rose-thorn-preview.png"
    }), "\n", _jsx("a", {
      href: "/uploads/wallpapers/rose-thorn.png",
      download: true,
      children: _jsx(_components.p, {
        children: "Download Rose Thorn (5120 x 2880 pixels)"
      })
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
